import React from 'react'
import PublisherForm from './PublisherForm'

const PublisherFieldArray = ({ includeSelect, formatLabel, initialValues, userTerritoryPresets, fields, remove, errors }) => {
  const hasError = errors && errors.ownerships

  return (<>
    {fields.map((ownership, index) => {
      return (
        <PublisherForm
          remove={remove}
          initialValues={initialValues}
          ownership={ownership}
          index={index}
          includeSelect={includeSelect}
          formatLabel={formatLabel}
          userTerritoryPresets={userTerritoryPresets}
          errors={hasError ? errors.ownerships[index] : null}
        />)
    })}
  </>)
}

export default PublisherFieldArray
